<template>
  <b-modal
    id="editDirectionModal"
    size="lg"
    :title="title"
    @ok="onSave"
    @show="updateData"
  >
    <b-form-group label="Классификатор">
      <MultiSelect
        required
        :value="formData.group"
        :options="directionGroups"
        label="codeTitle"
        @input="onSelectGroup"
      />
    </b-form-group>
    <b-form-group label="Код">
      <b-form-input
        v-mask="'##.##.##'"
        required
        v-model="formData.code"
        placeholder="11.22.33"
      />
    </b-form-group>
    <b-form-group label="Название">
      <b-form-input
        required
        v-model="formData.title"
      />
    </b-form-group>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button @click="ok" variant="primary" :disabled="isDisabled">
        Сохранить
      </b-button>
      <b-button @click="cancel" variant="outline-primary">
        Отмена
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mask } from 'vue-the-mask'
import MultiSelect from '@/components/ui/MultiSelect.vue'
import RecommendationAPI from '@/api/recommendation'

export default {
  name: 'EditDirectionModal',
  directives: { mask },
  components: {
    MultiSelect
  },
  props: {
    editData: {
      type: Object,
      default: null
    }
  },
  watch: {
    editData: {
      deep: true,
      handler() {
        this.updateData()
      }
    }
  },
  data() {
    return {
      title: '',
      addTitle: 'Добавление направления',
      editTitle: 'Редактирование направления',
      formData: {
        id: null,
        title: '',
        code: ''
      },
      directionGroups: []
    }
  },
  computed: {
    isDisabled() {
      return !(this.formData && this.formData.group && this.formData.group.length
        && this.formData.code && this.formData.code.length === 8
        && this.formData.title)
    }
  },
  async created() {
    const response = await RecommendationAPI.getDirectionGroups()
    this.directionGroups = response.data
      .map((dg) => ({ ...dg, codeTitle: `${dg.code} ${dg.title}` }))
  },
  methods: {
    updateData() {
      this.formData = this.editData
        ? {
          ...this.editData,
          group: [this.directionGroups.find((dg) => dg.id === this.editData.group.id)]
        }
        : this.clearData()
      this.title = this.editData ? this.editTitle : this.addTitle
    },
    onSelectGroup(data) {
      this.formData.group = [data]
    },
    onSave() {
      this.$emit('save', this.formData)
    },
    clearData() {
      return {
        id: null,
        title: '',
        code: '',
        group: []
      }
    }
  }
}
</script>

<style scoped>

</style>
